import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { PushNotificationItemDto } from "../data-models/notification.data.models";
// import { TranslateService } from "@ngx-translate/core";

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    notifications: NotificationMsg[]=[] ;
    pushNotificationItems:PushNotificationItemDto[]=[];
    unreadPushNotificationsCount:number=0;

    constructor(private translateService: TranslateService ) {

    }
    error(message: string) {
        const translatedMessage = this.translateService.instant(message);
        this.addNotification({type:'error',message:translatedMessage,styleClass:'error_toaster_show'});
    }

    success(message: string) {
        const translatedMessage = this.translateService.instant(message);
        this.addNotification({type:'success',message:translatedMessage,styleClass:'success_toaster_show'});
    }

    warning(message: string) {
        const translatedMessage = this.translateService.instant(message);
        this.addNotification({type:'warning',message:translatedMessage,styleClass:'warning_toaster_show'});
    }
    info(message: string) {
        const translatedMessage = this.translateService.instant(message);
        this.addNotification({type:'info',message:translatedMessage,styleClass:'info_toaster_show'});
    }

    addNotification(notification:NotificationMsg) {
        // Parallel requests can fail with the same message, show it only once
        const isDuplicate = this.notifications.some(
            x => x.type === notification.type && x.message === notification.message
        );
        if (isDuplicate) return;

        this.notifications.push(notification);
        setTimeout(() => this.removeNotification(notification), 5000); // Auto-remove after 5 seconds
      }
    
      removeNotification(notification: NotificationMsg) {
        const index = this.notifications.indexOf(notification);
        if (index >= 0) {
          this.notifications.splice(index, 1);
        }
      }
    
      closeAllNotifications() {
        this.notifications = [];
      }
}
export interface NotificationMsg{
    type:'success'|'error'|'warning'|'info',
    message:string,
    styleClass:string
}